import * as Yup from "yup";

import { fetchMethod } from "../../FetchMethod";

export const addUsersForm = {
  title: "Add New",
  fields: [
    localStorage.getItem("role") === "ADMIN"
      ? {
          label: "Role",
          type: "staticSelect",
          name: "role",
          isRequired: true,
          value: "Select Role",
          placeholder: "Select Role",
          data: [
            { name: "Campaign Manager", value: "CAMPAIGNMANAGER" },
            { name: "Customer", value: "CUSTOMER" }
          ]
        }
      : {
          label: "Role",
          type: "staticSelect",
          name: "role",
          placeholder: "Select Role",
          isRequired: true,
          value: "Select Role",
          data: [
            { name: "Admin", value: "ADMIN" },
            { name: "Campaign Manager", value: "CAMPAIGNMANAGER" },
            { name: "Customer", value: "CUSTOMER" }
          ]
        },
    {
      label: "Email",
      type: "input",
      placeholder: "e.g. smith.doe@gmail.com",
      isRequired: true,
      name: "email",
      value: ""
    },
    {
      label: "First Name",
      type: "input",
      placeholder: "e.g. John",
      isRequired: true,
      name: "firstName",
      value: ""
    },
    {
      label: "Last Name",
      type: "input",
      placeholder: "e.g. John",
      name: "lastName",
      value: ""
    },
    {
      label: "Phone Number",
      placeholder: "e.g. 9854795626",
      type: "input",
      name: "contactnumber",
      value: ""
    },
 
    {
      label: "Customers",
      type: "dynamicSelect2",
      name: "customerid",
      value: "Select Customer",
      placeholder: "Select Customer",
      data: "params",
      key1: "company",
      isRequired: true,
      disabled: true
    },
    {
      label: "Status",
      type: "radio",
      name: "status",
      value: "1",
      options: [
        { name: "Active", value: "1" },
        { name: "Inactive", value: "0" }
      ]
    },
    {
      label: "ABM",
      type: "radio",
      name: "abm",
      value: "1",
      options: [
        { name: "Active", value: "1" },
        { name: "Inactive", value: "0"}
      ]
    },

    {
      label: "Password",
      placeholder: "Password",
      isRequired: true,
      type: "password",
      name: "password",
      value: ""
    },
    {
      label: "Confirm Password",
      type: "password",
      placeholder: "Confirm password",
      isRequired: true,
      name: "confirmPassword",
      value: ""
    }
  ]
};

export const editUsersForm = {
  fields: [
    localStorage.getItem("role") === "ADMIN"
      ? {
          label: "Role",
          type: "staticSelect",
          isRequired: true,
          name: "role",
          value: "Select",
          placeholder: "Select Role",
          data: [
            
            { name: "Campaign Manager", value: "CAMPAIGNMANAGER" },
            { name: "Customer", value: "CUSTOMER" }
          ]
        }
      : {
          label: "Role",
          type: "staticSelect",
          isRequired: true,
          name: "role",
          value: "Select",
          placeholder: "Select Role",
          data: [
            { name: "Admin", value: "ADMIN" },
            { name: "Campaign Manager", value: "CAMPAIGNMANAGER" },
            { name: "Customer", value: "CUSTOMER" }
          ]
        },
    {
      label: "Email",
      type: "input",
      placeholder: "e.g. smith.doe@gmail.com",
      isRequired: true,
      name: "email",
      active: true,
      value: ""
    },
    {
      label: "First Name",
      type: "input",
      placeholder: "e.g. John",
      isRequired: true,
      name: "firstName",
      value: ""
    },
    {
      label: "Last Name",
      type: "input",
      placeholder: "e.g. Smith",
      name: "lastName",
      value: ""
    },
    {
      label: "Phone Number",
      placeholder: "e.g. 9854795626",
      type: "input",
      name: "contactnumber",
      value: ""
    },

    {
      label: "Customers",
      type: "dynamicSelect2",
      name: "customerid",
      value: "Select Customer",
      placeholder: "Select Customer",
      data: "params",
      key1: "company",
      isRequired: true,
      disabled: true
    },
    {
      label: "Status",
      type: "radio",
      name: "status",
      value: "1",
      options: [
        { name: "Active", value: "1" },
        { name: "Inactive", value: "0" }
      ]
    },
    {
      label: "ABM",
      type: "radio",
      name: "abm",
      value: "1",
      options: [
        { name: "Active", value: "1" },
        { name: "Inactive", value: "0"}
      ]
    },
    {
      label: "Password",
      type: "password",
      placeholder: "Password",
      name: "newPassword",
      value: ""
    },
    {
      label: "Confirm Password",
      type: "password",
      placeholder: "Confirm password",
      name: "confirmPassword",
      value: ""
    }
  ]
};

export const usersValidation = Yup.object().shape({
  email: Yup.string()
    .required("Please enter email-id")
    .matches(
        /^(([^<>()\[\].,;:\s@"]+(\.[^<>()\[\].,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z-0-9]+\.)+[a-zA-Z]{2,}))$/,
     // /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      {
        message: "Please enter valid email-id",
        excludeEmptyString: true
      }
    )
    // .email("Please enter a valid Email-ID")
    .max(50, "Email should be less than 50 characters"),
  contactnumber: Yup.string()
    .matches(/^\+?[0-9]*$/, {
      message: "Please enter valid phone no.",
      excludeEmptyString: true
    })
    .max(16, "Phone Number should be less than 16 digits"),
  firstName: Yup.string()
    .required("Please enter name")
    .matches(/^[a-zA-Z ]+$/, {
      message: "Only alphabets allowed",
      excludeEmptyString: true
    })
    .test("character-found", "Space not allowed here", value => {
      if (value !== undefined && value.trim().length === 0 && value !== "")
        return false;
      else return true;
    })
    .max(30, "First name should be less than 30 characters"),
  lastName: Yup.string()
    .matches(/^[a-zA-Z ]+$/, {
      message: "Only alphabets allowed",
      excludeEmptyString: true
    })
    .test("character-found", "Space not allowed here", data => {
      if (data !== undefined && data.trim().length === 0 && data !== "")
        return false;
      else return true;
    })
    .max(30, "Last name should be less than 30 characters"),
  password: Yup.string()
    .required("Please enter password")
    .matches(/^[^\s]+([^\s]+)*$/, {
      message: "Password can't contain spaces",
      excludeEmptyString: true
    })
    .min(8, "Password should be minimum 8 characters")
    .max(60, "Password should be maximum 60 characters"),

  confirmPassword: Yup.string()
    .required("Please re-enter password")
    .matches(/^[^\s]+([^\s]+)*$/, {
      message: "Please enter valid confirm password",
      excludeEmptyString: true
    })
    .test("passwords-match", "Passwords do not match! please check.", function(
      value
    ) {
      return this.parent.password === value;
    })
    .min(8, "Confirm password should be minimum 8 characters"),
  role: Yup.string()
    .ensure()
    .test("role", "Please select role", value => {
      return value !== "Select Role";
    }),
  // .required("Please select role"),
  customerid: Yup.string().when("role", {
    is: "CUSTOMER",
    then: Yup.string()
      .ensure()
      .test("customerid", "Please select customer", function(value) {
        return value !== "Select Customer";
      })
  })
});

export const editUsersValidation = Yup.object().shape({
  newPassword: Yup.string()
    // .required("Please enter Password")
    .matches(/^[^\s]+([^\s]+)*$/, {
      message: "Password can't contain spaces",
      excludeEmptyString: true
    })
    .min(8, "Password should be minimum 8 characters")
    .max(60, "Password should be maximum 60 characters"),
  confirmPassword: Yup.string()
    .matches(/^[^\s]+([^\s]+)*$/, {
      message: "Please enter valid confirm password",
      excludeEmptyString: true
    })
    .when("newPassword", {
      is: val => {
        return val && val.length > 0;
      },
      then: Yup.string()
        .test("confirmMessage", "Please re-enter password", value => {
          return !!value === true;
        })
        .test(
          "passwords-match",
          "Passwords do not match! please check.",
          function(value) {
            return this.parent.newPassword === value;
          }
        )
    })
    .min(8, "Confirm password should be minimum 8 characters"),
  email: Yup.string()
    .required("Please enter email-id")
    .matches(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      {
        message: "Please enter valid email-id",
        excludeEmptyString: true
      }
    )
    // .email("Please enter a valid Email-ID")
    .max(50, "Email should be less than 50 characters"),
  contactnumber: Yup.string()
    .matches(/^\+?[0-9]*$/, {
      message: "Please enter valid phone no.",
      excludeEmptyString: true
    })
    .max(16, "Phone number should be less than 16 digits"),
  firstName: Yup.string()
    .required("Please enter name")
    .matches(/^[a-zA-Z ]+$/, {
      message: "Only alphabets allowed",
      excludeEmptyString: true
    })
    .test("character-found", "Space not allowed here", value => {
      if (value !== undefined && value.trim().length === 0 && value !== "")
        return false;
      else return true;
    })
    .max(30, "First name should be less than 30 characters"),
  lastName: Yup.string()
    .matches(/^[a-zA-Z ]+$/, {
      message: "Only alphabets allowed",
      excludeEmptyString: true
    })
    .test("character-found", "Space not allowed here", data => {
      if (data !== undefined && data.trim().length === 0 && data !== "")
        return false;
      else return true;
    })
    .max(30, "Last name should be less than 30 characters"),
  role: Yup.string()
    .ensure()
    .test("role", "Please select role", value => {
      return value !== "Select";
    }),
  customerid: Yup.string().when("role", {
    is: "CUSTOMER",
    then: Yup.string()
      .ensure()
      .test("customerid", "Please select customer", function(value) {
        return value !== "Select Customer";
      })
  })
});

const users = id => `query {allUsersdata(where:{id: ${id}}) {
Usersdata {
id
email
firstName
lastName
status
role
abm
contactnumber
customerid
}
}}`;

export const getData = async id =>
  await fetchMethod(users(id))
    .then(response => response.json().then(data => data))
    .catch(e => console.log("Errror", e));
